import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, InputGroup, Row, Col } from 'react-bootstrap';

/**
 * Home-page search input: navigates to /search?q= on submit.
 * Pass initialQuery to sync the field with the URL (e.g. on SearchResultsPage).
 */
export default function WelcomeSearchForm({
  initialQuery = '',
  onQueryChange,
  onSearchSubmit,
  rowClassName = 'justify-content-center mb-4',
}) {
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const navigate = useNavigate();

  useEffect(() => {
    setSearchQuery(initialQuery);
  }, [initialQuery]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmed = searchQuery.trim();
    if (!trimmed) {
      return;
    }
    onSearchSubmit?.(trimmed);
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  const handleChange = (e) => {
    const next = e.target.value;
    setSearchQuery(next);
    onQueryChange?.(next);
  };

  return (
    <Row className={rowClassName}>
      <Col md={8} lg={6}>
        <Form onSubmit={handleSearchSubmit}>
          <InputGroup className="mb-3">
            <Form.Control
              type="search"
              placeholder="Search for supermarkets, products, or UPC..."
              aria-label="Search query"
              value={searchQuery}
              onChange={handleChange}
              className="welcome-search-input"
            />
            <Button type="submit" className="welcome-search-button">
              Search
            </Button>
          </InputGroup>
        </Form>
      </Col>
    </Row>
  );
}
